import React from 'react'
import _ from 'lodash'
import T from 'prop-types'

import withSession from 'hoc/withSession'
import withFeatures from 'hoc/withFeatures'
import compose from 'utils/compose'
import { Button, Text } from '@wework/dieter-ui'
import { Menu } from 'semantic-ui-react'
import { DotMenu } from '../Icons'
import { getUnread, getWhatsNew } from '../../utils/whatsnew-utils'
import Badge from '../Badge'
import IMTheme from '../../style/IMTheme'
class ProfileMenu extends React.PureComponent {
  state = {
    anchorEl: null,
    open: false,
  }

  handleClose = () => {
    this.setState({ open: false, anchorEl: null })
  }

  handleClickOnButton = e => {
    this.setState({
      anchorEl: e.currentTarget,
      open: !this.state.open,
    })
  }

  onSelect = value => () => {
    if (this.props.onSelect) {
      this.props.onSelect(value)
    }
    this.handleClose()
  }

  renderAvatar = () => {
    const iconColor = this.state.open
      ? IMTheme.colors.primary
      : IMTheme.colors.darkGray
    const borderColor = this.state.open
      ? IMTheme.colors.primary
      : IMTheme.colors.gray

    return (
      <div
        style={{
          position: 'relative',
          width: 40,
          height: 40,
          margin: 0,
          border: `1px solid ${borderColor}`,
          borderRadius: '4px',
          padding: '12px',
        }}
        onClick={this.handleClickOnButton}
      >
        <DotMenu color={iconColor} />
        <Badge value={getUnread()} />
      </div>
    )
  }

  render() {
    const { session } = this.props
    const { open } = this.state
    const email = _.get(session, 'user_data.email', '')
    const showCompat = this.props.isFeatureEnabled('compactMenu')
    return (
      <div>
        <div
          size="small"
          style={{ cursor: 'pointer' }}
          onClick={this.handleClickOnButton}
        >
          {this.renderAvatar()}
        </div>
        {open && (
          <Menu
            vertical
            pointing
            position="bottom"
            style={{ position: 'absolute', right: 16, top: 60 }}
          >
            <>
              <Menu.Item
                disabled={!getWhatsNew().length > 0}
                onClick={this.onSelect('whatsnew')}
                style={{
                  background: '#ffffff',
                  minHeight: 40,
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                }}
              >
                <Text size="small">What's New</Text>{' '}
                <Badge value={getUnread()} />
              </Menu.Item>
              <Menu.Item
                onClick={() =>
                  window.open(
                    'https://docs.google.com/forms/d/e/1FAIpQLScKaCyy9c8JKkhuySA3Ho3ijbQaELTWN2lqoP3onYXPdqY7XQ/viewform'
                  )
                }
                style={{
                  background: '#ffffff',
                  minHeight: 40,
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                }}
                name="Feedback"
                // active={activeItem === 'messages'}
              />
              <Menu.Item
                onClick={this.onSelect('logout')}
                style={{
                  background: '#ffffff',
                  minHeight: 40,
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                }}
                name="Logout"
              />
            </>
          </Menu>
        )}
      </div>
    )
  }
}

ProfileMenu.propTypes = {
  session: T.object,
  classes: T.object,
}

ProfileMenu.defaultProps = {
  session: {},
  classes: {},
}

export default compose(withSession(), withFeatures())(ProfileMenu)
